<template>
  <div class="pt-4 mb-6 text-xs">
    <!-- Mobile Filters -->
    <div class="md:hidden">
      <button
        class="uppercase font-normal text-base tracking-wide"
        @click="expanded = !expanded"
      >
        <h2>Filters <span v-text="expanded ? '-' : '+'" /></h2>
      </button>
      <expandable :expanded="expanded">
        <ul class="mt-0.5">
          <li
            v-for="filter in filters"
            :key="filter.filterOptionId"
          >
            <collection-filter
              ref="collectionFilter"
              :filter="filter"
              @filter-expanded="collapseSiblingFilters($event)"
            />
          </li>
        </ul>
      </expandable>
      <collection-selected-tags />
    </div>
    <!-- Desktop Filters -->
    <div class="hidden md:block">
      <ul class="flex justify-between space-x-12 mt-1">
        <li
          v-for="filter in filters"
          :key="filter.filterOptionId"
        >
          <collection-filter
            :filter="filter"
            :mobile="false"
          />
        </li>
      </ul>
      <collection-selected-tags />
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState } = createNamespacedHelpers('collection')

export default {
  data: function () {
    return {
      expanded: false,
    }
  },
  computed: mapState(['filters']),
  methods: {
    collapseSiblingFilters(filter) {
      this.$refs['collectionFilter'].forEach(ref => {
        if (ref != filter) {
          ref.collapse()
        }
      })
    },
  },
}
</script>
